import AKHI_EXT_1 from "./AKHI_EXT_1";

export default {
  AKHI_EXT_1,
};
